import {
  BrowserMessageType,
  DirectUploadProgress,
  DirectUploadState,
  sendElectronMessage,
} from 'electron-communication-lib/BrowserForApp';
import {action, computed, makeObservable, observable} from 'mobx';

export class DirectUpload {
  public readonly id: string;
  public readonly casusId: string;
  public readonly casusDisplayNameWithClient: string;
  public readonly folderId: string;
  public readonly paths: readonly string[];
  public readonly onCompleted: () => void;
  public documentCount: number | null = null;
  public uploadedCount = 0;
  public state: DirectUploadState = 'UPLOADING';

  public constructor({
    id,
    casusId,
    casusDisplayNameWithClient,
    folderId,
    paths,
    onCompleted,
  }: {
    id: string;
    casusId: string;
    casusDisplayNameWithClient: string;
    folderId: string;
    paths: readonly string[];
    onCompleted: () => void;
  }) {
    makeObservable(this, {
      documentCount: observable,
      uploadedCount: observable,
      state: observable,
      progress: computed,
      abortable: computed,
      abort: action.bound,
      applyProgress: action.bound,
      reset: action.bound,
    });
    this.id = id;
    this.casusId = casusId;
    this.casusDisplayNameWithClient = casusDisplayNameWithClient;
    this.folderId = folderId;
    this.paths = paths;
    this.onCompleted = onCompleted;
  }

  public get progress(): number | undefined {
    if (this.documentCount === null) {
      return undefined;
    }
    return this.documentCount === 0
      ? 1
      : this.uploadedCount / this.documentCount;
  }

  public get abortable(): boolean {
    return this.state === 'UPLOADING';
  }

  public abort(): void {
    sendElectronMessage({
      type: BrowserMessageType.ABORT_DIRECT_UPLOAD,
      payload: {entryId: this.id},
    });
  }

  public applyProgress({
    documentCount,
    uploadedCount,
    state,
  }: DirectUploadProgress): void {
    this.documentCount = documentCount;
    this.uploadedCount = uploadedCount;
    this.state = state;
  }

  public reset(): void {
    this.documentCount = null;
    this.uploadedCount = 0;
    this.state = 'UPLOADING';
  }
}
